module.exports = __webpack_public_path__ + "static/media/YAB5.acf08f66.jpg";